import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { switchMap } from 'rxjs';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SheetTemplatesService } from 'app/modules/settings/sheet-templates/sheet-templates.service';

@Component({
  selector: 'sheet-templates-add',
  templateUrl: './add-template.component.html',
  styleUrls: ['./add-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SheetTemplatesAddComponent extends OnDestroyMixin implements OnInit {
  public addSheetTemplateForm: UntypedFormGroup;
  public fileFormats: string[] = ['.xlsx, .csv, .xls'];

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly sheetTemplatesService: SheetTemplatesService,
    private readonly matDialogRef: MatDialogRef<SheetTemplatesAddComponent>,
  ) {
    super();
  }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.addSheetTemplateForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      fileControl: ['', [Validators.required]],
    });
  }

  public onImportFileChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const file: File | null = inputElement.files[0];
    this.addSheetTemplateForm.get('fileControl').setValue(file);
  }

  public saveAndClose(): void {
    this.addSheetTemplateForm.disable();
    let sheetTemplate = this.addSheetTemplateForm.value;
    this.sheetTemplatesService
      .createSheetTemplate(sheetTemplate)
      .pipe(
        untilComponentDestroyed(this),
        switchMap((sheetTemplate) => {
          return this.sheetTemplatesService.uploadDocument(
            sheetTemplate,
            this.addSheetTemplateForm.get('fileControl').value,
          );
        }),
      )
      .subscribe((result) => this.discard(result));
  }

  public discard(data?: any): void {
    this.matDialogRef.close(data);
  }
}
